import Switch, { ReactSwitchProps } from "react-switch"

import { ThemeName, useCurrentTheme, useTheme } from "@/theme"
import { withSubscribe } from "@/utils/withSubscribe"

export type ThemeStorageSwitchProps = Partial<ReactSwitchProps>

export const ThemeStorageSwitch = withSubscribe(
  (props: ThemeStorageSwitchProps) => {
    const theme = useCurrentTheme()
    const { themeName, toggleTheme } = useTheme()

    return (
      <Switch
        onChange={toggleTheme}
        checked={themeName === ThemeName.Dark}
        checkedIcon={false}
        uncheckedIcon={false}
        height={12}
        width={27}
        handleDiameter={12}
        offColor={theme.color["Colors/Background/bg-disabled"]}
        offHandleColor={theme.color["Colors/Foreground/fg-disabled"]}
        onColor={theme.color["Colors/Background/bg-disabled"]}
        onHandleColor={theme.color["Colors/Foreground/fg-brand-primary (600)"]}
        {...props}
      />
    )
  },
)
